import { TableProps } from '@amzn/awsui-components-core';
import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { withAppContext } from '../../contexts/AppContext';
import AppContextProps from '../../contexts/AppContextProps';
import Breadcrumbs from '../common/Breadcrumbs';
import PageCanvas from '../common/PageCanvas';
import {
  ApprovalsCol,
  ContainsCodeCol,
  ContentAudienceCol,
  ContentIdCol,
  ContentTypeCol,
  DisapprovalsCol,
  IsTestDataCol,
  OwnerCol,
  ReviewerContentNameCol,
  UpdatedDateCol,
  ReviewerContentActionCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentWorkflowTable from '../workflow-viewer/ContentWorkflowTable';
import ReviewRequestStatusColumn from '../workflow-viewer/ReviewRequestStatusColumn';

interface ContentsToReviewState {
  isLoading: boolean;
  contentWorkflows: ContentWorkflow[];
}

class ContentsToReview extends React.Component<AppContextProps, ContentsToReviewState> {
  private mplServiceClient: IMplServiceClient;
  // need user profile info, so it needs to be defined in here
  private ReviewRequestActionCol = {
    cell: (i: ContentWorkflow) => (
      <ReviewRequestStatusColumn
        workflow={i}
        // @ts-expect-error TS2532 - strict migration
        userProfile={this.props.appContext.authnInfo.userProfile}
      />
    ),
    header: '',
    id: 'reviewrequestaction',
  };
  private columnDefinitions: Array<TableProps.ColumnDefinition<ContentWorkflow>> = [
    ContainsCodeCol,
    ContentIdCol,
    ContentAudienceCol,
    ReviewerContentNameCol,
    ContentTypeCol,
    OwnerCol,
    UpdatedDateCol,
    ApprovalsCol,
    DisapprovalsCol,
    IsTestDataCol,
    this.ReviewRequestActionCol,
    ReviewerContentActionCol,
  ];

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.state = {
      contentWorkflows: [],
      isLoading: true,
    };
  }

  public componentDidMount() {
    this.loadData();
  }

  public render() {
    const { isLoading, contentWorkflows } = this.state;
    const breadcrumbItems = [
      { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
      { text: constants.REVIEWER_CONTENTS_HEADER, href: '' },
    ];
    return (
      <div>
        <Breadcrumbs items={breadcrumbItems} />
        <PageCanvas headerText={constants.REVIEWER_CONTENTS_HEADER}>
          <ContentWorkflowTable
            tableId={WorkflowTableIdentity.ContentsToReview}
            loading={isLoading}
            onRefreshClick={this.loadData}
            workflows={contentWorkflows}
            columnDefinitions={this.columnDefinitions}
            allowedFilterTypes={['contentType']}
          />
        </PageCanvas>
      </div>
    );
  }

  private loadData = async () => {
    this.setState({
      isLoading: true,
    });
    // @ts-expect-error TS2339 - strict migration
    const { userProfile } = this.props.appContext.authnInfo;
    const response = await this.mplServiceClient.listContentsAssignedToReview(userProfile.userId);
    this.setState({
      contentWorkflows: response.workflows,
      isLoading: false,
    });
  };
}

export default withAppContext(ContentsToReview);
